import { useEffect } from 'react';

import { listenPezinho } from '../../channels/pezinhoChannel';

import { useMapStore } from '../../stores/map/useMapStore';

export function usePezinhoChannel() {

    useEffect(() => {

        const unsubscribe = listenPezinho(({ tipo, payload }) => {

            const {
                setPezinhoActive,
                setPezinhoPeriod,
                setPezinhoVehicles,
                setPezinhoSelectedVehicles,
                setPezinhoSelectedPosition,
                resetPezinhoSearch,
                clearPezinhoResults,
                clearPezinho
            } = useMapStore.getState();

            // =========================
            // ACTIVE
            // =========================

            if (tipo === 'pezinho-active') {

                setPezinhoActive(payload, false);

            }

            // =========================
            // PERIOD
            // =========================

            if (tipo === 'pezinho-period') {

                setPezinhoPeriod(payload, false);

            }

            // =========================
            // VEHICLES
            // =========================

            if (tipo === 'pezinho-vehicles') {

                setPezinhoVehicles(payload, false);

            }

            // =========================
            // SELECTED VEHICLES
            // =========================

            if (tipo ===  'pezinho-selected-vehicles') {

                setPezinhoSelectedVehicles(payload, false);

            }

            // =========================
            // SELECTED POSITION
            // =========================

            if (tipo === 'pezinho-selected-position') {

                setPezinhoSelectedPosition(payload, false);

            }

            // =========================
            // RESET SEARCH
            // =========================

            if (tipo === 'pezinho-reset-search') {

                resetPezinhoSearch(false);

            }

            // =========================
            // CLEAR RESULTS
            // =========================

            if (tipo === 'pezinho-clear-results') {

                clearPezinhoResults(false);

            }

            // =========================
            // CLEAR
            // =========================

            if (tipo === 'pezinho-clear') {

                clearPezinho(false);

            }

        });

        return unsubscribe;

    }, []);

}